import MenuItem from "@/lib/menu/MenuItem";

export default class extends MenuItem {
  constructor(title, icon, enabled = true, children = [], permissions = undefined) {
    super(Math.random(), title, null, enabled, icon, permissions, children)
    this.isGroup = true
  }
}